import { urlLoadProduct } from "../../../urls";
import { useLocation, useNavigate } from "react-router";
import { useBarcodeScanner } from "../../../hooks/use-barcode-scanner";
import { IS_DEV } from "../../../constants";
import { Button } from "@repo/ui/components/button";
import { Title } from "../../../components/title";

function Sku() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const handleScan = (sku: string) => {
    navigate(urlLoadProduct("category"), {
      state: { ...state, sku },
    });
  };

  useBarcodeScanner({
    onScan: handleScan,
  });

  return (
    <div className="flex flex-col items-center justify-center gap-4 w-full py-4 flex-1">
      <Title>Escanea el código de barras del producto</Title>
      {IS_DEV && (
        <Button
          className="text-2xl! font-bold! py-4"
          onClick={() =>
            handleScan(Math.random().toString(36).substring(2, 15))
          }
        >
          Fake Scan
        </Button>
      )}
    </div>
  );
}

export const route = {
  path: urlLoadProduct("sku"),
  element: <Sku />,
  handle: {
    title: "Escanea el código de barras del producto",
  },
};
